import { useOutlet } from 'react-router-dom';

/**
 * A layout component that wraps pages embedded in QESTField Web
 *
 * Note we don't do any customisation here. Instead we use this to set properties on
 * the window object that other components refer to.
 */
export const EmbeddedInQESTFieldLayout = () => {
  const outlet = useOutlet();
  window.qest.isFrame = true;
  window.qest.userAgent = navigator.userAgent + ' [QFW]';

  return outlet;
};
